import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Popup from './Popup.vue'
import { computed } from 'vue'
import { usePopupStore } from '@/stores/PopupStore'


export default /*@__PURE__*/_defineComponent({
  __name: 'PopupMap',
  props: {
  cableLength: Number
},
  setup(__props) {



const popupStore = usePopupStore()

const easting = computed(() => popupStore.easting)
const northing = computed(() => popupStore.northing)

const popupHeight = computed(() => {
  if (popupStore.showCabel) {
    return -175
  } else if (popupStore.showVessel) {
    return -240
  }
  return 0
})

return (_ctx: any,_cache: any) => {
  const _component_ol_overlay = _resolveComponent("ol-overlay")!
  const _component_ol_vector_layer = _resolveComponent("ol-vector-layer")!

  return (_openBlock(), _createBlock(_component_ol_vector_layer, null, {
    default: _withCtx(() => [
      _createVNode(_component_ol_overlay, {
        position: [easting.value, northing.value],
        autoPan: false,
        offset: [-320, popupHeight.value]
      }, {
        default: _withCtx(() => [
          _createVNode(Popup, {
            cableLength: __props.cableLength,
            id: "popup"
          }, null, 8, ["cableLength"])
        ]),
        _: 1
      }, 8, ["position", "offset"])
    ]),
    _: 1
  }))
}
}

})